// reducers/loadingReducer.js

import { SET_LOADING } from '../actions/actionTypes';

const initialState = {
  isLoading: false
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
};

export default loadingReducer;
